// https://github.com/biati-digital/glightbox
import 'glightbox/dist/css/glightbox.css';
import GLightbox from 'glightbox';

let glightboxOpenCount = 0;
let savedScrollY = 0;

const lockPageScroll = () => {
    if (glightboxOpenCount === 0) {
        savedScrollY = window.scrollY || window.pageYOffset || 0;
        document.body.classList.add('glightbox-scroll-lock-active');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${savedScrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }
    glightboxOpenCount += 1;
};

const unlockPageScroll = () => {
    glightboxOpenCount = Math.max(0, glightboxOpenCount - 1);

    if (glightboxOpenCount === 0) {
        const htmlEl = document.documentElement;
        const previousScrollBehavior = htmlEl.style.scrollBehavior;
        document.body.classList.add('glightbox-restoring-scroll');
        // Prevent smooth scrolling animation when restoring position.
        htmlEl.style.scrollBehavior = 'auto';

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        if (Math.abs((window.scrollY || window.pageYOffset || 0) - savedScrollY) > 1) {
            window.scrollTo(0, savedScrollY);
        }

        // Restore previous behavior on next frame after instant jump.
        window.requestAnimationFrame(() => {
            htmlEl.style.scrollBehavior = previousScrollBehavior;
            window.setTimeout(() => {
                document.body.classList.remove('glightbox-restoring-scroll');
                document.body.classList.remove('glightbox-scroll-lock-active');
            }, 120);
        });
    }
};

const bindScrollLock = (instance) => {
    instance.on('open', lockPageScroll);
    instance.on('close', unlockPageScroll);
};


// Standard lightbox (Bilder, Galerie — nicht `teamboxlink`, die gehen an die Teambox-Instanz unten)
const lightbox = GLightbox({
    selector: '.glightbox',
});
bindScrollLock(lightbox);

//search box header
$(document).ready(function() {

    const teambox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: '.teamboxlink',
        zoomable: false,
        draggable: false,
        width: '1200px',
        height: 'auto',
        skin: 'teambox',
    });
    bindScrollLock(teambox);
    teambox.on('open', () => {
        $('.button--close--teambox')
            .off('click.teambox')
            .on('click.teambox', function () {
                teambox.close();
            });
    });

    const searchbox = GLightbox({
        touchNavigation: false,
        touchFollowAxis: false,
        keyboardNavigation: false,
        selector: ".searchboxlink",
        zoomable: false,
        draggable: false,
        height: 'auto'
    });
    bindScrollLock(searchbox);
    searchbox.on('open', () => {
        $('input[type="search"]').select();
        $('.button--close').click(function() {
            searchbox.close();
        })
    });

});
